module.exports = __webpack_public_path__ + "img/noContent.9dcc8d17.png";